import { render, staticRenderFns } from "./UserAttendance.vue?vue&type=template&id=1596edf4&scoped=true&"
import script from "./UserAttendance.vue?vue&type=script&lang=js&"
export * from "./UserAttendance.vue?vue&type=script&lang=js&"
import style0 from "./UserAttendance.vue?vue&type=style&index=0&id=1596edf4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596edf4",
  null
  
)

export default component.exports